// import AsyncStorage from '@react-native-async-storage/async-storage';



type AuthAction = { type: 'signIn', payload: any } |
{ type: 'signOut' } |
{ type: 'changePermisos', payload: string } |
{ type: 'changeAccesos', payload: string } |
{ type: 'setIdPersonal', payload: string | null };


export const authReducer = (state: any, action: AuthAction): any => {
    switch (action.type) {
        case "signIn":
            return {
                ...state,
                isLogged: true,
                // favoriteIcon: action.payload.favoriteIcon,
                ...action.payload
                // idUser: action.payload.idUser,
                // Usuario: action.payload.Usuario,
                // UserName: action.payload.UserName,
                // Mail: action.payload.Mail,
                // IdRol: action.payload.IdRol,
                // IdStatus: action.payload.IdStatus,
                // Rol: action.payload.Rol,
                // StatusCategory: action.payload.StatusCategory,
                // StatusName: action.payload.StatusName,
                // Token: action.payload.Token,
                // PermisosWeb: action.payload.PermisosWeb,
                // IP: action.payload.IP,
                // idPersonal: action.payload.idPersonal? action.payload.idPersonal : null,
            };


        case "signOut":
            return {
                ...state,
                isLogged: false,
                Usuario: '',
            };
            break;


        case "changePermisos":
            const user = {
                ...state,
                PermisosWeb: action.payload,
            };
            // AsyncStorage.setItem('user', JSON.stringify(user));
            return user;
            break;


        case "setIdPersonal":
            const a = {
                ...state,
                idPersonal: action.payload,
            };
            // AsyncStorage.setItem('user', JSON.stringify(a));
            // AsyncStorage.setItem('idPersonal', action.payload!);
            return a;
            break;

        case "changeAccesos":
            const u = {
                ...state,
                Accesos: action.payload,
            };
            // AsyncStorage.setItem('user', JSON.stringify(u));
            return u;
            break;


        default:
            return state;
    }
}